import React from 'react';

const PoliticaPrivacidad = () => (
  <div className="container py-5">
    <h2 className="mb-4">Política de Privacidad</h2>
    <p><strong>Última actualización:</strong> 29 de marzo de 2025</p>

    <h4>1. Responsable del tratamiento</h4>
    <p>
      Ayuntamiento o Administración Local correspondiente. Contacto: [correo institucional].
    </p>

    <h4>2. Finalidad del tratamiento</h4>
    <p>
      Gestionar el acceso al sistema, registrar actividad relacionada con colonias felinas y generar informes técnicos o administrativos.
    </p>

    <h4>3. Legitimación</h4>
    <p>
      Consentimiento explícito de la persona usuaria y cumplimiento de una misión realizada en interés público (art. 6.1.e RGPD).
    </p>

    <h4>4. Destinatarios</h4>
    <p>
      No se cederán datos a terceros salvo obligación legal. Se garantiza tratamiento dentro del Espacio Económico Europeo.
    </p>

    <h4>5. Conservación</h4>
    <p>
      Los datos se conservarán mientras esté activa la cuenta y posteriormente según normativa vigente.
    </p>

    <h4>6. Derechos</h4>
    <p>
      Acceso, rectificación, supresión, oposición, limitación y portabilidad. Reclamaciones ante la Agencia Española de Protección de Datos.
    </p>

    <h4>7. Medidas de seguridad</h4>
    <p>
      Aplicación de medidas técnicas y organizativas adecuadas para proteger la información.
    </p>
  </div>
);

export default PoliticaPrivacidad;